(function(){

var gid=function(id){return document.getElementById(id);};
var txt=function(id){var el=gid(id);return el?el.value.trim():'';};

/* ── Dominios de análisis ────────────────────────────────────────────────── */
var DOMAINS=[
  {id:'url',label:'URL y protocolo',short:'URL',owasp:'A04:2025, A02:2025',asvs:'V1.9, V9.1'},
  {id:'hdr',label:'Cabeceras HTTP de seguridad',short:'Cabeceras',owasp:'A02:2025',asvs:'V14.4, V14.5'},
  {id:'tls',label:'Configuración TLS/SSL',short:'TLS',owasp:'A04:2025',asvs:'V9.1, V9.2'},
  {id:'cok',label:'Cookies y sesiones',short:'Cookies',owasp:'A02:2025, A07:2025',asvs:'V3.4, V3.5'},
  {id:'inf',label:'Information disclosure',short:'Disclosure',owasp:'A02:2025, A03:2025',asvs:'V14.3, V14.4'},
  {id:'dns',label:'Configuración DNS y correo',short:'DNS',owasp:'A04:2025, A02:2025',asvs:'V14.5'},
  {id:'exp',label:'Archivos y rutas expuestas',short:'Exposición',owasp:'A02:2025, A01:2025',asvs:'V14.3'}
];

var SEV_COLOR={'Crítico':'#dc2626','Alto':'#ea580c','Medio':'#d97706','Bajo':'#16a34a','Info':'#0d6efd'};
var EFFORT_COLOR={'Bajo':'#16a34a','Medio':'#d97706','Alto':'#dc2626'};

function badge(t,c){return '<span class="psq-badge" style="background:'+c+'22;color:'+c+';border:1px solid '+c+'55">'+t+'</span>';}
function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
function scoreColor(s){return s>=70?'#16a34a':s>=40?'#d97706':'#dc2626';}
function scoreLbl(s){return s>=70?'Postura Adecuada':s>=40?'Postura Mejorable':'Postura Deficiente';}
function sevOrder(s){return {'Crítico':0,'Alto':1,'Medio':2,'Bajo':3,'Info':4}[s];}
function scrollToTop(){var r=gid('psq-root');if(r){window.scrollTo({top:r.getBoundingClientRect().top+window.pageYOffset-16,behavior:'smooth'});}}

/* ── Estado ──────────────────────────────────────────────────────────────── */
var state={
  view:'form',
  url:'',
  parsed:null,
  findings:[],
  scores:{},
  progress:0,
  stage:'',
  f:{}
};
var radarChart=null;

/* ── Normalización de URL ────────────────────────────────────────────────── */
function normalizeUrl(input){
  input=(input||'').trim();
  if(!input)return null;
  if(!/^https?:\/\//i.test(input)){input='https://'+input;}
  try{
    var u=new URL(input);
    return {
      raw:input,
      href:u.href,
      protocol:u.protocol.replace(':',''),
      host:u.hostname,
      port:u.port||(u.protocol==='https:'?'443':'80'),
      path:u.pathname||'/',
      isIP:/^(\d{1,3}\.){3}\d{1,3}$/.test(u.hostname)||/^\[.+\]$/.test(u.hostname),
      hostParts:u.hostname.split('.'),
      isLocalhost:/^(localhost|127\.|0\.0\.0\.0|::1)/.test(u.hostname),
      hasPunycode:u.hostname.indexOf('xn--')>=0
    };
  }catch(e){return null;}
}

/* ── Análisis 1: URL y protocolo (offline) ───────────────────────────────── */
function analyzeUrl(p){
  var F=[];
  if(p.protocol==='http'){
    F.push({id:'URL-01',sev:'Crítico',dom:'url',title:'Sitio accesible por HTTP (sin cifrado)',
      desc:'La URL analizada utiliza HTTP en lugar de HTTPS. Todo el tráfico, incluidas credenciales y cookies de sesión, viaja en claro y es interceptable por cualquier atacante en red (Man-in-the-Middle).',
      impact:'Robo de credenciales, secuestro de sesión, inyección de contenido malicioso, incumplimiento GDPR.',
      rec:'Migrar todo el sitio a HTTPS. Redirigir 301 de HTTP a HTTPS. Activar HSTS con preload.',
      owasp:'A04:2025',asvs:'V9.1.1, V9.1.2',cwe:'CWE-319',ef:'Medio'});
  }
  if(p.isIP){
    F.push({id:'URL-02',sev:'Medio',dom:'url',title:'Acceso directo por IP en lugar de dominio',
      desc:'El destino analizado es una dirección IP. Esto impide validación de certificado por nombre y es un patrón habitual en campañas de phishing y C2 de malware.',
      impact:'Certificado TLS probablemente inválido por hostname mismatch. Indicador de riesgo para usuarios.',
      rec:'Exponer el servicio bajo un dominio propio con certificado TLS válido (Let\'s Encrypt).',
      owasp:'A02:2025',asvs:'V9.1.1',cwe:'CWE-295',ef:'Bajo'});
  }
  if(p.hasPunycode){
    F.push({id:'URL-03',sev:'Alto',dom:'url',title:'Dominio con caracteres Punycode (IDN)',
      desc:'El dominio contiene caracteres internacionalizados codificados (xn--). Los dominios IDN son una técnica habitual de homograph attacks para suplantar marcas legítimas.',
      impact:'Posible suplantación visual del dominio. Riesgo de phishing contra usuarios desprevenidos.',
      rec:'Verificar si el dominio IDN es legítimo. Considerar registrar variantes homográficas del dominio principal.',
      owasp:'A02:2025',asvs:'V1.9',cwe:'CWE-1007',ef:'Bajo'});
  }
  var stdPorts={'http':'80','https':'443'};
  if(p.port&&stdPorts[p.protocol]&&p.port!==stdPorts[p.protocol]){
    F.push({id:'URL-04',sev:'Bajo',dom:'url',title:'Puerto no estándar ('+p.port+')',
      desc:'El servicio se expone en un puerto diferente al estándar del protocolo. Puede indicar paneles administrativos expuestos.',
      impact:'Mayor superficie de ataque si el puerto expone un panel no pensado para producción.',
      rec:'Validar que el servicio en este puerto es público por diseño. Limitar por IP si es administrativo.',
      owasp:'A02:2025',asvs:'V14.1',cwe:'CWE-1327',ef:'Bajo'});
  }
  if(p.isLocalhost){
    F.push({id:'URL-05',sev:'Info',dom:'url',title:'URL apunta a localhost',
      desc:'La URL introducida corresponde a un recurso local. El análisis pasivo desde navegador no puede evaluar recursos no accesibles desde Internet.',
      impact:'No aplicable al análisis pasivo externo.',
      rec:'Introducir un dominio o URL público para obtener resultados representativos.',
      owasp:'N/A',asvs:'N/A',cwe:'N/A',ef:'Bajo'});
  }
  if(p.protocol==='https'&&!p.isIP){
    F.push({id:'TLS-01',sev:'Info',dom:'tls',title:'HTTPS activo',
      desc:'El sitio está accesible por HTTPS. Para un análisis completo de la configuración TLS (ciphers, versión, certificado) se recomienda Qualys SSL Labs.',
      impact:'Información.',
      rec:'Completar análisis TLS en https://www.ssllabs.com/ssltest/',
      owasp:'N/A',asvs:'V9.1',cwe:'N/A',ef:'Bajo'});
  }
  return F;
}

/* ── Análisis 2: DNS vía DNS-over-HTTPS ──────────────────────────────────── */
function dohQuery(name,type){
  var url='https://dns.google/resolve?name='+encodeURIComponent(name)+'&type='+encodeURIComponent(type);
  return fetch(url,{method:'GET'}).then(function(r){return r.json();}).catch(function(){return null;});
}

function analyzeDns(p){
  if(p.isIP||p.isLocalhost)return Promise.resolve([]);
  var host=p.host;
  var parts=host.split('.');
  var rootDomain=parts.length>=2?parts.slice(-2).join('.'):host;

  return Promise.all([
    dohQuery(rootDomain,'TXT'),
    dohQuery('_dmarc.'+rootDomain,'TXT'),
    dohQuery(rootDomain,'CAA'),
    dohQuery(rootDomain,'MX'),
    dohQuery(rootDomain,'DNSKEY')
  ]).then(function(r){
    var F=[];
    var txtRes=r[0],dmarcRes=r[1],caaRes=r[2],mxRes=r[3],dnskeyRes=r[4];

    // SPF
    var hasSPF=false;
    if(txtRes&&txtRes.Answer){
      for(var i=0;i<txtRes.Answer.length;i++){
        var d=String(txtRes.Answer[i].data||'').toLowerCase();
        if(d.indexOf('v=spf1')>=0){hasSPF=true;
          if(d.indexOf('+all')>=0||(d.indexOf('all')<0)){
            F.push({id:'DNS-01',sev:'Alto',dom:'dns',title:'Registro SPF permisivo o sin "all"',
              desc:'El dominio tiene SPF pero permite el envío desde cualquier origen (+all) o no termina en un mecanismo "all" explícito, lo que permite suplantación de correo.',
              impact:'Suplantación de identidad corporativa. Éxito elevado en campañas de phishing dirigidas.',
              rec:'Terminar el SPF con "-all" (rechazar) o "~all" (soft fail). Revisar mecanismos include autorizados.',
              owasp:'A02:2025',asvs:'V14.5.1',cwe:'CWE-290',ef:'Bajo'});
          }
        }
      }
    }
    if(!hasSPF&&txtRes){
      F.push({id:'DNS-02',sev:'Alto',dom:'dns',title:'Sin registro SPF configurado',
        desc:'El dominio no publica un registro SPF, permitiendo que cualquier servidor envíe correo en su nombre sin restricción.',
        impact:'Suplantación de identidad corporativa (spoofing). Daño reputacional y éxito elevado en phishing.',
        rec:'Publicar un registro TXT SPF válido: "v=spf1 include:<proveedor_correo> -all".',
        owasp:'A02:2025',asvs:'V14.5.1',cwe:'CWE-290',ef:'Bajo'});
    }

    // DMARC
    var hasDmarc=false,dmarcPolicy='';
    if(dmarcRes&&dmarcRes.Answer){
      for(var j=0;j<dmarcRes.Answer.length;j++){
        var dm=String(dmarcRes.Answer[j].data||'').toLowerCase();
        if(dm.indexOf('v=dmarc1')>=0){hasDmarc=true;
          var m=dm.match(/p=(none|quarantine|reject)/);
          dmarcPolicy=m?m[1]:'';
          if(dmarcPolicy==='none'){
            F.push({id:'DNS-03',sev:'Medio',dom:'dns',title:'DMARC en modo monitorización (p=none)',
              desc:'El dominio tiene DMARC pero su política es "none". Esto solo monitoriza sin bloquear correo fraudulento.',
              impact:'Correos suplantados llegan al buzón del destinatario. Mínimo nivel de protección real.',
              rec:'Tras periodo de monitorización, endurecer la política a p=quarantine y finalmente p=reject.',
              owasp:'A02:2025',asvs:'V14.5.1',cwe:'CWE-290',ef:'Bajo'});
          }
        }
      }
    }
    if(!hasDmarc&&dmarcRes){
      F.push({id:'DNS-04',sev:'Alto',dom:'dns',title:'Sin política DMARC publicada',
        desc:'No se detecta registro DMARC en _dmarc.'+rootDomain+'. Sin DMARC, SPF y DKIM no son exigibles por el receptor.',
        impact:'Imposible diferenciar correo legítimo de suplantado. Alto riesgo de phishing exitoso.',
        rec:'Publicar "_dmarc" TXT con "v=DMARC1; p=quarantine; rua=mailto:dmarc@dominio.com".',
        owasp:'A02:2025',asvs:'V14.5.1',cwe:'CWE-290',ef:'Bajo'});
    }

    // CAA
    var hasCaa=!!(caaRes&&caaRes.Answer&&caaRes.Answer.length>0);
    if(!hasCaa&&caaRes){
      F.push({id:'DNS-05',sev:'Bajo',dom:'dns',title:'Sin registro CAA configurado',
        desc:'El dominio no restringe qué autoridades certificadoras pueden emitir certificados TLS para él.',
        impact:'Cualquier CA puede emitir un certificado válido, ampliando la superficie de mis-issuance.',
        rec:'Publicar registros CAA limitando las CAs autorizadas (ej. letsencrypt.org, digicert.com).',
        owasp:'A04:2025',asvs:'V9.1.3',cwe:'CWE-295',ef:'Bajo'});
    }

    // DNSSEC
    var hasDnssec=!!(dnskeyRes&&dnskeyRes.Answer&&dnskeyRes.Answer.length>0)||!!(dnskeyRes&&dnskeyRes.AD);
    if(!hasDnssec&&dnskeyRes){
      F.push({id:'DNS-06',sev:'Bajo',dom:'dns',title:'Dominio sin DNSSEC',
        desc:'El dominio no utiliza DNSSEC. Las respuestas DNS no están firmadas y son susceptibles a envenenamiento de caché.',
        impact:'Posible redirección maliciosa mediante envenenamiento DNS. Riesgo en entornos hostiles.',
        rec:'Activar DNSSEC en el registrador de dominios y publicar el registro DS en la zona padre.',
        owasp:'A04:2025',asvs:'V14.5.1',cwe:'CWE-345',ef:'Medio'});
    }

    // MX
    if(mxRes&&mxRes.Answer&&mxRes.Answer.length>0){
      F.push({id:'DNS-07',sev:'Info',dom:'dns',title:'Registros MX detectados',
        desc:'El dominio tiene '+mxRes.Answer.length+' registro(s) MX configurados. El dominio acepta correo entrante, por lo que SPF/DMARC/DKIM son especialmente importantes.',
        impact:'Información.',
        rec:'Verificar que SPF, DKIM y DMARC estén correctamente configurados.',
        owasp:'N/A',asvs:'V14.5.1',cwe:'N/A',ef:'Bajo'});
    }

    return F;
  }).catch(function(){return [];});
}

/* ── Análisis 3: HTTP — cabeceras, cookies, disclosure ───────────────────── */
function analyzeHttp(p){
  return fetch(p.href,{method:'GET',mode:'cors',redirect:'follow',credentials:'omit'})
    .then(function(r){
      var F=[];
      var h={};
      if(r.headers){r.headers.forEach(function(v,k){h[k.toLowerCase()]=v;});}
      if(Object.keys(h).length>0){
        F=F.concat(analyzeHeaders(h));
      } else {
        F.push({id:'HDR-00',sev:'Info',dom:'hdr',title:'Cabeceras HTTP no verificables desde navegador',
          desc:'El servidor respondió pero CORS restringe la lectura de cabeceras desde un contexto cross-origin. La validación real requiere herramientas server-side.',
          impact:'No se ha podido auditar las cabeceras automáticamente.',
          rec:'Completar el análisis en https://securityheaders.com o https://observatory.mozilla.org',
          owasp:'N/A',asvs:'V14.4',cwe:'N/A',ef:'Bajo'});
      }
      return F;
    })
    .catch(function(){
      return [{id:'HDR-00',sev:'Info',dom:'hdr',title:'Dominio no accesible desde el navegador (CORS/red)',
        desc:'La petición HTTP al dominio falló. Causa probable: restricciones CORS (el servidor no permite peticiones cross-origin), bloqueo de mixed content, o el dominio no responde. Esto es habitual y no indica un problema de seguridad por sí mismo.',
        impact:'El análisis pasivo de cabeceras, cookies y disclosure requiere herramientas externas.',
        rec:'Usar securityheaders.com, Mozilla Observatory o Qualys SSL Labs para completar el análisis.',
        owasp:'N/A',asvs:'N/A',cwe:'N/A',ef:'Bajo'}];
    });
}

function analyzeHeaders(h){
  var F=[];
  // HSTS
  if(!h['strict-transport-security']){
    F.push({id:'HDR-01',sev:'Alto',dom:'hdr',title:'Falta cabecera Strict-Transport-Security (HSTS)',
      desc:'No se detecta HSTS. Los usuarios pueden ser víctimas de SSL-stripping en la primera conexión o en redes hostiles.',
      impact:'Downgrade a HTTP mediante MITM. Robo de credenciales en redes no fiables.',
      rec:'Añadir: Strict-Transport-Security: max-age=31536000; includeSubDomains; preload',
      owasp:'A04:2025',asvs:'V9.1.2',cwe:'CWE-319',ef:'Bajo'});
  } else {
    var hstsMax=(h['strict-transport-security'].match(/max-age=(\d+)/)||[])[1];
    if(hstsMax&&parseInt(hstsMax)<15552000){
      F.push({id:'HDR-02',sev:'Medio',dom:'hdr',title:'HSTS con max-age insuficiente',
        desc:'HSTS configurado con max-age='+hstsMax+'s, por debajo del mínimo recomendado (6 meses = 15552000).',
        impact:'Protección reducida frente a SSL-stripping persistente.',
        rec:'Incrementar max-age a 31536000 (1 año) y considerar inclusión en preload list de Chromium.',
        owasp:'A04:2025',asvs:'V9.1.2',cwe:'CWE-319',ef:'Bajo'});
    }
  }
  // CSP
  if(!h['content-security-policy']&&!h['content-security-policy-report-only']){
    F.push({id:'HDR-03',sev:'Alto',dom:'hdr',title:'Falta Content-Security-Policy (CSP)',
      desc:'No se detecta CSP. La aplicación carece de mitigación efectiva frente a XSS, inyección de código y data injection.',
      impact:'Sin defensa en profundidad contra XSS, el impacto de un XSS llega al máximo.',
      rec:'Implementar CSP con directivas estrictas: default-src \'self\'; script-src \'self\' \'nonce-...\'; object-src \'none\'.',
      owasp:'A02:2025',asvs:'V14.4.3',cwe:'CWE-693',ef:'Alto'});
  } else if(h['content-security-policy']){
    var csp=h['content-security-policy'].toLowerCase();
    if(csp.indexOf('unsafe-inline')>=0||csp.indexOf('unsafe-eval')>=0){
      F.push({id:'HDR-04',sev:'Medio',dom:'hdr',title:'CSP permite unsafe-inline o unsafe-eval',
        desc:'La política CSP contiene unsafe-inline o unsafe-eval, reduciendo significativamente su eficacia frente a XSS.',
        impact:'La CSP pasa a ser principalmente simbólica; inyección de scripts sigue siendo viable.',
        rec:'Eliminar unsafe-inline/eval. Usar nonces o hashes para scripts inline legítimos.',
        owasp:'A02:2025',asvs:'V14.4.3',cwe:'CWE-693',ef:'Medio'});
    }
  }
  // X-Frame-Options
  if(!h['x-frame-options']&&(!h['content-security-policy']||h['content-security-policy'].toLowerCase().indexOf('frame-ancestors')<0)){
    F.push({id:'HDR-05',sev:'Medio',dom:'hdr',title:'Falta protección contra clickjacking',
      desc:'Ni X-Frame-Options ni CSP frame-ancestors están presentes. El sitio puede ser embebido en iframes de terceros.',
      impact:'Ataques de clickjacking, especialmente en paneles administrativos y formularios sensibles.',
      rec:'Añadir X-Frame-Options: DENY o CSP frame-ancestors \'none\'.',
      owasp:'A02:2025',asvs:'V14.4.7',cwe:'CWE-1021',ef:'Bajo'});
  }
  // X-Content-Type-Options
  if(!h['x-content-type-options']||h['x-content-type-options'].toLowerCase()!=='nosniff'){
    F.push({id:'HDR-06',sev:'Medio',dom:'hdr',title:'Falta X-Content-Type-Options: nosniff',
      desc:'El navegador puede hacer MIME-sniffing del contenido, abriendo vectores de XSS en ficheros servidos con tipo incorrecto.',
      impact:'Contenido malicioso puede ser ejecutado aunque se sirva con un Content-Type inofensivo.',
      rec:'Añadir: X-Content-Type-Options: nosniff.',
      owasp:'A02:2025',asvs:'V14.4.4',cwe:'CWE-430',ef:'Bajo'});
  }
  // Referrer-Policy
  if(!h['referrer-policy']){
    F.push({id:'HDR-07',sev:'Bajo',dom:'hdr',title:'Falta Referrer-Policy',
      desc:'Sin política de Referer, se envía la URL completa a todos los recursos externos, pudiendo filtrar tokens en query string.',
      impact:'Fuga de URLs sensibles (tokens, IDs) a CDNs, analytics y recursos de terceros.',
      rec:'Añadir: Referrer-Policy: strict-origin-when-cross-origin.',
      owasp:'A02:2025',asvs:'V14.4.6',cwe:'CWE-200',ef:'Bajo'});
  }
  // Permissions-Policy
  if(!h['permissions-policy']){
    F.push({id:'HDR-08',sev:'Bajo',dom:'hdr',title:'Sin Permissions-Policy',
      desc:'No se restringe el uso de APIs potentes del navegador (cámara, geolocalización, micrófono, etc.).',
      impact:'Si la app es comprometida, el atacante puede activar APIs sensibles sin restricción.',
      rec:'Añadir Permissions-Policy limitando las APIs no necesarias: "camera=(), geolocation=(), microphone=()".',
      owasp:'A02:2025',asvs:'V14.4',cwe:'CWE-732',ef:'Bajo'});
  }
  // Server / X-Powered-By
  if(h['server']&&/\d/.test(h['server'])){
    F.push({id:'INF-01',sev:'Medio',dom:'inf',title:'Cabecera Server expone versión',
      desc:'El servidor responde con Server: '+h['server']+'. Revelar la versión facilita la búsqueda de CVEs aplicables.',
      impact:'Fingerprinting inmediato. Facilita la explotación dirigida de vulnerabilidades conocidas.',
      rec:'Ocultar o limpiar la cabecera Server (ServerTokens Prod en Apache, server_tokens off en Nginx).',
      owasp:'A02:2025',asvs:'V14.3.2',cwe:'CWE-200',ef:'Bajo'});
  }
  if(h['x-powered-by']){
    F.push({id:'INF-02',sev:'Medio',dom:'inf',title:'Cabecera X-Powered-By expone tecnología',
      desc:'El servidor expone X-Powered-By: '+h['x-powered-by']+'. Revela la tecnología subyacente y su versión.',
      impact:'Fingerprinting. Facilita ataques dirigidos contra vulnerabilidades específicas de la plataforma.',
      rec:'Desactivar X-Powered-By (expose_php=Off en PHP).',
      owasp:'A02:2025',asvs:'V14.3.2',cwe:'CWE-200',ef:'Bajo'});
  }
  if(h['x-aspnet-version']||h['x-aspnetmvc-version']){
    F.push({id:'INF-03',sev:'Medio',dom:'inf',title:'Versión de ASP.NET expuesta',
      desc:'El servidor expone X-AspNet-Version o X-AspNetMvc-Version. Facilita la explotación dirigida.',
      impact:'Fingerprinting de la plataforma y explotación de vulnerabilidades específicas.',
      rec:'Añadir en web.config: <httpRuntime enableVersionHeader="false" />.',
      owasp:'A02:2025',asvs:'V14.3.2',cwe:'CWE-200',ef:'Bajo'});
  }
  // Cookies
  var sc=h['set-cookie'];
  if(sc){
    var cl=sc.toLowerCase();
    if(cl.indexOf('secure')<0){
      F.push({id:'COK-01',sev:'Alto',dom:'cok',title:'Cookies sin flag Secure',
        desc:'Una o más cookies se emiten sin el flag Secure, por lo que pueden enviarse sobre HTTP en claro.',
        impact:'Robo de cookies en conexiones HTTP. Secuestro de sesión vía MITM.',
        rec:'Marcar todas las cookies de sesión con el atributo Secure.',
        owasp:'A02:2025',asvs:'V3.4.1',cwe:'CWE-614',ef:'Bajo'});
    }
    if(cl.indexOf('httponly')<0){
      F.push({id:'COK-02',sev:'Alto',dom:'cok',title:'Cookies sin flag HttpOnly',
        desc:'Las cookies sin HttpOnly son accesibles desde JavaScript. Un XSS las roba de inmediato.',
        impact:'Robo de cookies de sesión ante cualquier XSS, incluyendo secuestro completo de la cuenta.',
        rec:'Añadir el atributo HttpOnly a todas las cookies de sesión y autenticación.',
        owasp:'A02:2025, A07:2025',asvs:'V3.4.2',cwe:'CWE-1004',ef:'Bajo'});
    }
    if(cl.indexOf('samesite')<0){
      F.push({id:'COK-03',sev:'Medio',dom:'cok',title:'Cookies sin atributo SameSite',
        desc:'Sin SameSite, las cookies se envían en peticiones cross-site, exponiendo el sitio a CSRF.',
        impact:'Ataques CSRF contra acciones autenticadas.',
        rec:'Configurar SameSite=Lax o SameSite=Strict según el caso de uso.',
        owasp:'A02:2025',asvs:'V3.4.3',cwe:'CWE-352',ef:'Bajo'});
    }
  }
  return F;
}

/* ── Análisis 4: Archivos expuestos ──────────────────────────────────────── */
function analyzeExposed(p){
  if(p.isLocalhost)return Promise.resolve([]);
  var base=p.protocol+'://'+p.host+(p.port!=='80'&&p.port!=='443'?':'+p.port:'');
  var paths=[
    {path:'/robots.txt',sev:'Info',title:'robots.txt accesible',id:'EXP-01',pos:true,
     desc:'Archivo robots.txt presente. Puede exponer rutas internas que se quieren ocultar a buscadores.',
     rec:'Revisar que robots.txt no revele directorios sensibles (/admin, /backup, /.git).'},
    {path:'/sitemap.xml',sev:'Info',title:'sitemap.xml accesible',id:'EXP-02',pos:true,
     desc:'Sitemap accesible. Información típica y generalmente deseable, pero revisar que no contenga URLs privadas.',
     rec:'Verificar que el sitemap no incluya URLs de staging, administración o recursos privados.'},
    {path:'/.well-known/security.txt',sev:'Info',title:'security.txt accesible',id:'EXP-03',pos:true,
     desc:'Fichero security.txt presente. Buena práctica RFC 9116.',
     rec:'Mantenerlo actualizado con contactos reales y política de disclosure.'},
    {path:'/.git/HEAD',sev:'Crítico',title:'Repositorio .git expuesto',id:'EXP-04',
     desc:'Se detecta exposición del directorio .git. Permite descarga completa del código fuente, historial y secretos commiteados.',
     rec:'Bloquear el acceso a /.git en el servidor web. Rotar inmediatamente cualquier secreto commiteado.'},
    {path:'/.env',sev:'Crítico',title:'Archivo .env accesible',id:'EXP-05',
     desc:'Archivo .env expuesto. Habitualmente contiene API keys, contraseñas de BBDD y secretos en texto plano.',
     rec:'Bloquear el acceso a /.env. Rotar todas las credenciales expuestas. Mover secretos a vault.'},
    {path:'/wp-config.php.bak',sev:'Crítico',title:'Backup de wp-config accesible',id:'EXP-06',
     desc:'Copia de seguridad de wp-config.php accesible. Contiene credenciales de base de datos en claro.',
     rec:'Eliminar backups del webroot. Rotar credenciales de BBDD inmediatamente.'},
    {path:'/.DS_Store',sev:'Bajo',title:'Archivo .DS_Store accesible',id:'EXP-07',
     desc:'Archivo .DS_Store de macOS expuesto. Revela estructura de directorios del equipo del desarrollador.',
     rec:'Añadir .DS_Store a .gitignore y eliminarlo del servidor.'},
    {path:'/server-status',sev:'Alto',title:'Apache server-status accesible',id:'EXP-08',
     desc:'Endpoint server-status de Apache expuesto. Muestra información detallada sobre peticiones en curso.',
     rec:'Restringir /server-status a IPs autorizadas o deshabilitar el módulo.'},
    {path:'/phpinfo.php',sev:'Alto',title:'phpinfo() accesible',id:'EXP-09',
     desc:'Archivo phpinfo.php accesible. Revela configuración completa del servidor PHP, rutas y variables.',
     rec:'Eliminar phpinfo.php del servidor inmediatamente.'}
  ];

  var checks=paths.map(function(cfg){
    return fetch(base+cfg.path,{method:'GET',mode:'cors',redirect:'follow',credentials:'omit'})
      .then(function(r){
        if(r.ok&&r.status<400){
          if(cfg.pos){
            return {id:cfg.id,sev:cfg.sev,dom:'exp',title:cfg.title,
              desc:cfg.desc,impact:cfg.sev==='Info'?'Información.':'Exposición de información o recursos sensibles.',
              rec:cfg.rec,owasp:'A02:2025',asvs:'V14.3',cwe:'CWE-538',ef:'Bajo'};
          }
          return {id:cfg.id,sev:cfg.sev,dom:'exp',title:cfg.title,
            desc:cfg.desc,impact:'Exposición crítica de información sensible. Compromiso inmediato posible.',
            rec:cfg.rec,owasp:'A02:2025, A01:2025',asvs:'V14.3.3',cwe:'CWE-538',ef:'Bajo'};
        }
        return null;
      }).catch(function(){return null;});
  });
  return Promise.all(checks).then(function(list){return list.filter(Boolean);});
}

/* ── Scoring ─────────────────────────────────────────────────────────────── */
function computeScores(findings){
  var sc={};
  DOMAINS.forEach(function(d){
    var domFindings=findings.filter(function(f){return f.dom===d.id&&f.sev!=='Info';});
    if(domFindings.length===0){sc[d.id]=85;return;}
    var penalty=0;
    domFindings.forEach(function(f){
      if(f.sev==='Crítico')penalty+=40;
      else if(f.sev==='Alto')penalty+=25;
      else if(f.sev==='Medio')penalty+=12;
      else if(f.sev==='Bajo')penalty+=5;
    });
    sc[d.id]=Math.max(0,Math.min(100,100-penalty));
  });
  return sc;
}
function overallScore(sc){
  var vals=Object.keys(sc).map(function(k){return sc[k];});
  return Math.round(vals.reduce(function(a,b){return a+b;},0)/vals.length);
}

/* ── Vista: switcher ─────────────────────────────────────────────────────── */
function showView(v){
  var vs=['pg-pentest-form','pg-pentest-scanning','pg-pentest-results'];
  var target={form:'pg-pentest-form',scanning:'pg-pentest-scanning',results:'pg-pentest-results'}[v];
  vs.forEach(function(id){var el=gid(id);if(el)el.style.display=(id===target?'block':'none');});
  state.view=v;
  scrollToTop();
}

/* ── Progreso ────────────────────────────────────────────────────────────── */
function setProgress(pct,stage){
  state.progress=pct;state.stage=stage;
  var bar=gid('pt-progress-bar'),st=gid('pt-progress-stage'),pt=gid('pt-progress-pct');
  if(bar)bar.style.width=pct+'%';
  if(st)st.textContent=stage;
  if(pt)pt.textContent=pct+'%';
}

/* ── Enviar a contacto (igual patrón que las otras herramientas) ─────────── */
function enviarContacto(f,ov){
  var url=window.CUATRIA_LEADS_URL;if(!url)return;
  fetch(url+'/lead',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({email:f.email,tool:'pentest',score:ov,name:f.responsible||'',client:f.client||'',date:f.date||''})
  }).catch(function(){});
}

/* ── Orquestador ─────────────────────────────────────────────────────────── */
function runAnalysis(){
  var rawUrl=txt('pt-url');
  var email=txt('pt-email');
  if(!rawUrl||!email){gid('pt-missing').style.display='block';return;}
  var p=normalizeUrl(rawUrl);
  if(!p){gid('pt-missing').style.display='block';return;}

  state.parsed=p;state.findings=[];
  state.f={
    url:p.href,email:email,
    client:txt('pt-client'),responsible:txt('pt-responsible'),
    date:new Date().toLocaleDateString('es-ES')
  };

  showView('scanning');
  var hostEl=gid('pt-target-host');if(hostEl)hostEl.textContent=p.host;
  setProgress(10,'Analizando URL y protocolo...');

  var urlFindings=analyzeUrl(p);
  state.findings=state.findings.concat(urlFindings);

  setProgress(30,'Consultando registros DNS (SPF, DMARC, CAA, DNSSEC)...');
  analyzeDns(p).then(function(dnsFindings){
    state.findings=state.findings.concat(dnsFindings);
    setProgress(55,'Analizando respuesta HTTP y cabeceras de seguridad...');
    return analyzeHttp(p);
  }).then(function(httpFindings){
    state.findings=state.findings.concat(httpFindings);
    setProgress(75,'Comprobando exposición de archivos comunes...');
    return analyzeExposed(p);
  }).then(function(expFindings){
    state.findings=state.findings.concat(expFindings);
    setProgress(95,'Calculando puntuación y generando informe...');
    state.findings.sort(function(a,b){return sevOrder(a.sev)-sevOrder(b.sev);});
    state.scores=computeScores(state.findings);
    var ov=overallScore(state.scores);
    enviarContacto(state.f,ov);
    setTimeout(function(){renderResults(ov);},300);
  }).catch(function(err){
    console.error('Error en análisis:',err);
    state.scores=computeScores(state.findings);
    renderResults(overallScore(state.scores));
  });
}

/* ── Radar ───────────────────────────────────────────────────────────────── */
function drawRadar(){
  var canvas=gid('pt-radarCanvas');if(!canvas)return;
  if(radarChart){radarChart.destroy();radarChart=null;}
  var data=DOMAINS.map(function(d){return state.scores[d.id];});
  radarChart=new Chart(canvas.getContext('2d'),{
    type:'radar',
    data:{labels:DOMAINS.map(function(d){return d.short;}),
      datasets:[{
        label:'Postura detectada',data:data,
        backgroundColor:'rgba(111,66,193,0.12)',borderColor:'#6f42c1',borderWidth:2,
        pointBackgroundColor:data.map(function(v){return scoreColor(v);}),pointRadius:4
      },{
        label:'Objetivo OWASP',data:DOMAINS.map(function(){return 85;}),
        backgroundColor:'transparent',borderColor:'#16a34a',borderWidth:1.5,borderDash:[4,2],pointRadius:0
      }]
    },
    options:{responsive:true,maintainAspectRatio:false,
      plugins:{legend:{display:true,position:'bottom',labels:{font:{size:11},padding:10}},
        tooltip:{callbacks:{label:function(c){return c.dataset.label+': '+c.parsed.r+'%';}}}},
      scales:{r:{min:0,max:100,
        ticks:{stepSize:25,color:'#94a3b8',font:{size:9},backdropColor:'transparent'},
        grid:{color:'#e2e8f0'},angleLines:{color:'#e2e8f0'},
        pointLabels:{color:'#64748b',font:{size:10}}}}}
  });
}

/* ── Renderizado de resultados ───────────────────────────────────────────── */
function renderResults(ov){
  var col=scoreColor(ov);
  var lbl=scoreLbl(ov);
  var cntC=state.findings.filter(function(f){return f.sev==='Crítico';}).length;
  var cntA=state.findings.filter(function(f){return f.sev==='Alto';}).length;
  var cntM=state.findings.filter(function(f){return f.sev==='Medio';}).length;
  var cntB=state.findings.filter(function(f){return f.sev==='Bajo';}).length;

  gid('pt-r-target').textContent=state.f.url;

  var parts=[];
  if(state.f.client)parts.push('Cliente: <strong>'+esc(state.f.client)+'</strong>');
  if(state.f.responsible)parts.push(esc(state.f.responsible));
  parts.push('Fecha: '+state.f.date);
  gid('pt-r-meta').innerHTML=parts.join(' | ');

  gid('pt-r-score').textContent=ov;gid('pt-r-score').style.color=col;
  gid('pt-r-label').textContent=lbl;gid('pt-r-label').style.background=col;
  gid('pt-cnt-crit').textContent=cntC;
  gid('pt-cnt-alto').textContent=cntA;
  gid('pt-cnt-medio').textContent=cntM;
  gid('pt-cnt-bajo').textContent=cntB;

  gid('pt-r-chips').innerHTML=DOMAINS.map(function(d){
    var v=state.scores[d.id],c=scoreColor(v);
    return '<div class="psq-chip" style="border:1px solid '+c+'44"><span style="color:#64748b">'+d.short+': </span><span style="color:'+c+';font-weight:700">'+v+'%</span></div>';
  }).join('');

  gid('pt-r-domain-grid').innerHTML=DOMAINS.map(function(d){
    var v=state.scores[d.id],c=scoreColor(v);
    return '<div class="psq-domain-card" style="border-top-color:'+c+'"><div style="font-size:22px;font-weight:700;color:'+c+'">'+v+'%</div><div style="font-size:11px;font-weight:600;color:#64748b;margin-top:2px">'+d.short+'</div><div style="font-size:10px;color:#94a3b8;margin-top:2px">OWASP</div></div>';
  }).join('');

  setTimeout(drawRadar,80);

  gid('pt-r-map-tbody').innerHTML=DOMAINS.map(function(d){
    var v=state.scores[d.id],c=scoreColor(v);
    var est=v>=70?'Adecuado':v>=40?'Mejorable':'Deficiente';
    return '<tr>'
      +'<td data-label="Dominio" style="font-weight:600">'+esc(d.label)+'</td>'
      +'<td data-label="Puntuación"><span style="font-weight:700;color:'+c+'">'+v+'%</span></td>'
      +'<td data-label="OWASP Top 10" style="color:#6f42c1">'+esc(d.owasp)+'</td>'
      +'<td data-label="ASVS 4.0.3" style="color:#13795b">'+esc(d.asvs)+'</td>'
      +'<td data-label="Estado"><span style="font-weight:600;color:'+c+'">'+est+'</span></td></tr>';
  }).join('');

  var riskHtml=state.findings.length?state.findings.map(function(r){
    var c=SEV_COLOR[r.sev]||'#64748b';
    return '<div class="psq-risk-item" style="border-color:'+c+'">'
      +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:6px;margin-bottom:4px;flex-wrap:wrap">'
      +'<h4 style="margin:0"><span style="color:#94a3b8;font-weight:500;font-size:11px;margin-right:6px">'+esc(r.id)+'</span>'+esc(r.title)+'</h4>'
      +badge(r.sev,c)+'</div>'
      +'<p style="margin:0 0 3px">'+esc(r.desc)+'</p>'
      +(r.impact?'<p style="margin:0 0 3px"><strong style="color:#1e293b">Impacto:</strong> '+esc(r.impact)+'</p>':'')
      +(r.rec?'<p style="margin:0 0 3px"><strong style="color:#1e293b">Recomendación:</strong> '+esc(r.rec)+'</p>':'')
      +'<small>'+(r.owasp&&r.owasp!=='N/A'?'OWASP '+esc(r.owasp)+' · ':'')+(r.asvs&&r.asvs!=='N/A'?'ASVS '+esc(r.asvs)+' · ':'')+(r.cwe&&r.cwe!=='N/A'?esc(r.cwe):'')+'</small>'
      +'</div>';
  }).join(''):'<p style="color:#16a34a;margin:0">No se han detectado hallazgos. Complementar con herramientas server-side.</p>';
  gid('pt-r-risk-list').innerHTML=riskHtml;

  var actionable=state.findings.filter(function(f){return f.sev!=='Info';});
  gid('pt-r-action-tbody').innerHTML=actionable.length?actionable.map(function(r,i){
    var sc2=SEV_COLOR[r.sev]||'#64748b';
    var ec=EFFORT_COLOR[r.ef]||'#64748b';
    return '<tr>'
      +'<td data-label="#" style="color:#6f42c1;font-weight:700">'+(i+1)+'</td>'
      +'<td data-label="ID" style="color:#64748b;font-size:11px">'+esc(r.id)+'</td>'
      +'<td data-label="Severidad">'+badge(r.sev,sc2)+'</td>'
      +'<td data-label="Acción" style="font-weight:500">'+esc(r.rec||r.title)+'</td>'
      +'<td data-label="Esfuerzo">'+badge(r.ef||'Medio',ec)+'</td>'
      +'<td data-label="OWASP" style="color:#6f42c1;font-size:11px">'+esc(r.owasp||'—')+'</td></tr>';
  }).join(''):'<tr><td colspan="6" style="text-align:center;color:#94a3b8">No hay acciones pendientes.</td></tr>';

  gid('pt-r-footer').textContent='Análisis pasivo ejecutado desde navegador · OWASP Top 10 2025 + ASVS 4.0.3 · '+new Date().toLocaleDateString('es-ES',{year:'numeric',month:'long',day:'numeric'});

  window._pentestData={f:state.f,parsed:state.parsed,scores:state.scores,overall:ov,findings:state.findings,col:col,lbl:lbl};
  showView('results');
}

/* ── Exportar PDF ────────────────────────────────────────────────────────── */
function exportPDF(){
  var jsPDF=window.jspdf?window.jspdf.jsPDF:null;if(!jsPDF)return;
  var d=window._pentestData;if(!d)return;
  var doc=new jsPDF({orientation:'portrait',unit:'mm',format:'a4'});
  doc.setLanguage('es');
  var F='helvetica';
  if(window._psqRobotoB64){
    doc.addFileToVFS('Roboto.ttf',window._psqRobotoB64);
    doc.addFont('Roboto.ttf','Roboto','normal');
    F='Roboto';
  }
  if(window._psqRobotoBoldB64){
    doc.addFileToVFS('Roboto-Bold.ttf',window._psqRobotoBoldB64);
    doc.addFont('Roboto-Bold.ttf','Roboto','bold');
  }

  function generarPDF(imgData,ratio){
    // ── Cabecera ─────────────────────────────────────────────────────────
    doc.setFillColor(111,66,193);doc.rect(0,0,210,28,'F');
    if(imgData){var lH=12,lW=lH*ratio;doc.addImage(imgData,'PNG',210-lW-10,8,lW,lH);}
    doc.setTextColor(255,255,255);doc.setFontSize(15);doc.setFont(F,'bold');
    doc.text('Informe de Pentesting Pasivo',14,12);
    doc.setFontSize(8);doc.setFont(F,'normal');
    doc.text('Target: '+(d.f.url||'-')+'   |   Fecha: '+d.f.date,14,22);
    doc.setTextColor(30,41,59);doc.setFontSize(13);doc.setFont(F,'bold');
    doc.text('Puntuación Global: '+d.overall+' / 100  -  '+d.lbl,14,38);
    if(d.f.client||d.f.responsible){
      doc.setFontSize(9);doc.setFont(F,'normal');doc.setTextColor(100,116,139);
      doc.text('Cliente: '+(d.f.client||'-')+'   |   Responsable: '+(d.f.responsible||'-'),14,44);
    }

    // ── Tabla 1: Dominios OWASP ──────────────────────────────────────────
    doc.autoTable({startY:50,
      head:[['Dominio','Puntuación','OWASP Top 10','ASVS 4.0.3','Estado']],
      body:DOMAINS.map(function(dm){var v=d.scores[dm.id];return[dm.label,v+'%',dm.owasp,dm.asvs,v>=70?'Adecuado':v>=40?'Mejorable':'Deficiente'];}),
      styles:{fontSize:8,font:F},headStyles:{fillColor:[111,66,193],font:F},margin:{left:14,right:14}});

    var y=doc.lastAutoTable.finalY+10;
    doc.setFontSize(12);doc.setFont(F,'bold');doc.setTextColor(220,38,38);
    doc.text('Hallazgos Identificados ('+d.findings.length+')',14,y);

    // ── Tabla 2: Hallazgos ───────────────────────────────────────────────
    doc.autoTable({startY:y+2,
      head:[['ID','Hallazgo','Severidad','Dominio','OWASP','Impacto']],
      body:d.findings.map(function(r){
        var domLbl=(DOMAINS.filter(function(x){return x.id===r.dom;})[0]||{}).short||r.dom;
        return[r.id,r.title,r.sev,domLbl,r.owasp||'—',r.impact||''];
      }),
      styles:{fontSize:7,cellPadding:2.5,font:F},headStyles:{fillColor:[220,38,38],font:F},margin:{left:14,right:14},columnStyles:{5:{cellWidth:55}}});

    y=doc.lastAutoTable.finalY+10;
    if(y>240){doc.addPage();y=20;}
    doc.setTextColor(111,66,193);doc.setFontSize(12);doc.setFont(F,'bold');
    doc.text('Plan de Acción Priorizado',14,y);

    // ── Tabla 3: Plan de acción ──────────────────────────────────────────
    var actionable=d.findings.filter(function(f){return f.sev!=='Info';});
    doc.autoTable({startY:y+2,
      head:[['#','ID','Severidad','Acción recomendada','Esfuerzo','OWASP']],
      body:actionable.map(function(r,i){return[i+1,r.id,r.sev,r.rec||r.title,r.ef||'Medio',r.owasp||'—'];}),
      styles:{fontSize:7,cellPadding:3,font:F},headStyles:{fillColor:[111,66,193],font:F},margin:{left:14,right:14},columnStyles:{3:{cellWidth:70}}});

    // ── Pie de página ────────────────────────────────────────────────────
    var pages=doc.getNumberOfPages();
    var disc='Este documento es el resultado de un análisis pasivo ejecutado desde el navegador del usuario. No sustituye un pentest profesional. Zerolynx no garantiza la exactitud de los resultados ni se hace responsable de las decisiones adoptadas en base a este informe.';
    for(var i=1;i<=pages;i++){doc.setPage(i);doc.setFontSize(6);doc.setFont(F,'normal');doc.setTextColor(148,163,184);doc.text(disc,14,289,{maxWidth:182});doc.text('Pág. '+i+'/'+pages,196,292,{align:'right'});}

    var now=new Date();var mm=String(now.getMonth()+1).padStart(2,'0');var yyyy=now.getFullYear();
    doc.save(yyyy+'-'+mm+'-InformePentestPasivo.pdf');
  }

  var img=new Image();img.crossOrigin='anonymous';
  img.onload=function(){var canvas=document.createElement('canvas');var maxW=320;var ratio=img.width/img.height;canvas.width=maxW;canvas.height=Math.round(maxW/ratio);canvas.getContext('2d').drawImage(img,0,0,canvas.width,canvas.height);generarPDF(canvas.toDataURL('image/png'),ratio);};
  img.onerror=function(){generarPDF(null,0);};
  img.src='https://cdn.shopify.com/s/files/1/0803/8658/9019/files/Zerolynx_Blanco_c5b3b306-c3fd-4960-857e-23bc5247a9c2.png?v=1775764507';
}

/* ── Validación del formulario ───────────────────────────────────────────── */
function checkForm(){
  var url=txt('pt-url');
  var email=txt('pt-email');
  var emailValid=email.length>0&&email.indexOf('@')>0&&email.indexOf('.')>0;
  var urlValid=url.length>2;
  var btn=gid('pt-start-btn');
  var valid=emailValid&&urlValid;
  if(btn){btn.disabled=!valid;btn.style.opacity=valid?'1':'0.5';btn.style.cursor=valid?'pointer':'not-allowed';}
}

/* ── API pública ─────────────────────────────────────────────────────────── */
function back(){showView('form');}
function fillExample(v){var el=gid('pt-url');if(el){el.value=v;el.focus();}checkForm();}

window.psqPentestStart=runAnalysis;
window.psqPentestBack=back;
window.psqPentestExportPDF=exportPDF;
window.psqPentestFill=fillExample;

window.psqPentestInit=function(){
  ['pt-url','pt-email'].forEach(function(id){
    var el=gid(id);
    if(el&&!el._psqInited){
      el._psqInited=true;
      el.addEventListener('input',checkForm);
      el.addEventListener('keyup',checkForm);
      el.addEventListener('change',checkForm);
    }
  });
  checkForm();
  showView('form');
};

})();